export default {
  items: [
    {
      _name: "CSidebarNav",
      _children: [
        {
          _name: "CSidebarNavDropdown",
          name: "Controle de entregas",
          route: "/controle",

          icon: "cil-chart-line",
          meta: { roles: "AD | SA" },

          items: [
            {
              name: "Mapa",
              to: "/controle/mapa_entregadores"
            },
            {
              name: "Detalhes",
              to: "/controle/solicitacao_detalhes"
            },
            {
              name: "Abrir solicitação",
              to: "/controle/solicitacao_admin"
            }
          ]
        },

        {
          _name: "CSidebarNavDropdown",
          name: "Solicitar",
          route: "/solicitar",
          icon: "cil-bell",
          meta: { roles: "CO" },
          items: [
            {
              name: "Nova solicitação",
              to: "/solicitar/solicitacoes"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Entregas",
          route: "/entregas",
          icon: "cil-bike",
          meta: { roles: "CO" },

          items: [
            {
              name: "Histórico",
              to: "/entregas/historico"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Entregas",
          route: "/entregas",
          icon: "cil-bike",
          meta: { roles: "PE | MT" },

          items: [
            {
              name: "Histórico",
              to: "/entregas/historico"
            },
            {
              name: "Cadastrar entrega",
              to: "/entregas/cadastro_entrega"
            },
            {
              name: "Cadastrar distribuição",
              to: "/entregas/cadastro_distribuicao"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Entregas",
          route: "/entregas",
          icon: "cil-bike",
          meta: {
            roles: "AD | SA "
          },

          items: [
            {
              name: "Histórico",
              to: "/entregas/historico"
            },
            {
              name: "Cadastrar entrega",
              to: "/entregas/cadastro_entrega"
            },
            {
              name: "Cadastrar distribuição",
              to: "/entregas/cadastro_distribuicao"
            },
            {
              name: "Entregador fixo",
              to: "/entregas/fixo"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Entregas",
          route: "/entregas",
          icon: "cil-bike",
          meta: {
            roles: "SP|SF"
          },

          items: [{
              name: "Histórico",
              to: "/entregas/historico"
            }

          ]
        },
        // {
        //   _name: 'CSidebarNavDropdown',
        //   name: 'Entregas',
        //   icon: 'cil-bike',
        //   meta: { roles: "CO" },

        //   items: [
        //     {
        //       name: 'Histórico',
        //       to: '/Entregas'
        //     }
        //   ]
        // },
        {
          _name: "CSidebarNavDropdown",
          name: "Financeiro",
          icon: "cil-balance-scale",
          route: "/financeiro",
          meta: { roles: "AD | SA" },

          items: [
            {
              name: "Caixa",
              to: "/financeiro/caixa"
            },
            {
              name: "Fazer acerto",
              to: "/financeiro/acerto"
            },
            {
              name: "Devolução pendente",
              to: "/financeiro/devolucao"
            },
            {
              name: "Configurações",
              to: "/financeiro/configuracoes"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Financeiro",
          icon: "cil-balance-scale",
          route: "/financeiro",
          meta: {
            roles: "SF"
          },

          items: [
            {
              name: "Fazer acerto",
              to: "/financeiro/acerto"
            },
            {
              name: "Devolução pendente",
              to: "/financeiro/devolucao"
            },

          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Financeiro",
          route: "/financeiro",
          icon: "cil-balance-scale",
          meta: { roles: "PE | MT" },

          items: [
            {
              name: "Saldo e extrato",
              to: "/financeiro/saldo"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Financeiro",
          route: "/financeiro",
          icon: "cil-balance-scale",
          meta: { roles: "CO" },

          items: [
            {
              name: "Saldo e extrato",
              to: "/financeiro/saldo"
            },
            {
              name: "Relatório de entregas parceiro",
              to: "/financeiro/relatorio_entregas_parceiro"
            }
          ]
        },

        {
          _name: "CSidebarNavItem",
          name: "Contestações",
          route: "/contestacoes",
          to: "/contestacoes",
          icon: "cil-warning",
          meta: { roles: "AD | SA | SF" }
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Agendamento",
          icon: "cil-calendar",
          meta: { roles: "SA" },

          items: [
            {
              name: "Agendamento bikers",
              to: "/agendamento"
            },
            {
              name: "Agendamento motoboys",
              to: "/AgendamentoMotoboy"
            },
            {
              name: "Configurações",
              to: "/ConfiguracoesAgen"
            }
          ]
        },
        // {
        //   _name: 'CSidebarNavDropdown',
        //   name: 'Configurações agendamento',
        //   icon: 'cil-settings',
        //   meta: { roles: "SA" },

        //   items: [
        //     {
        //       name: 'Editar turnos',
        //       to: '/turnos'
        //     },
        //     {
        //       name: 'Editar dias da semana',
        //       to: '/dias_semana'
        //     },
        //     {
        //       name: 'Editar status agendamento',
        //       to: '/status_agendamento'
        //     }

        //   ]
        // },

        {
          _name: "CSidebarNavItem",
          name: "Tabela de Preços",
          route: "/tabela_bairros",
          to: "/tabela_bairros",
          icon: "cil-clipboard",
          meta: { roles: "CO" }
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Tabelas de preços",
          route: "/tabelas_preco",
          icon: "cil-clipboard",
          meta: { roles: "AD | SA" },
          items: [
            {
              name: "Distribuição",
              to: "/tabelas_preco/tabela_distribuicao"
            },
            {
              name: "Entrega simples",
              to: "/tabelas_preco/tabela"
            }
            //TODO
            // {
            //   name: 'Editar áreas simples',
            //   to: '/tabelas_preco/edita_areas'
            // },
            // {
            //   name: 'Valor bairros novos',
            //   to: '/tabelas_preco/edita_areas'
            // }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Lista ruas",
          icon: "cil-folder",
          meta: {
            roles: "SP | SF"
          },
          items: [
            {
              name: "Lista ruas",
              to: "/lista_ruas"
            },

          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Editar ruas e bairros",
          icon: "cil-folder",
          meta: { roles: "AD | SA" },
          items: [
            {
              name: "Editar bairros",
              to: "/edita_bairro"
            },
            {
              name: "Editar ruas",
              to: "/edita_ruas"
            },
            {
              name: "Editar regras",
              to: "/edita_regras"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Usuários",
          icon: "cil-user",
          route: "/usuarios",
          meta: { roles: "AD | SA" },
          items: [
            {
              name: "Todos",
              to: "/usuarios/todos"
            },
            {
              name: "Bikers",
              to: "/usuarios/bikers"
            },
            {
              name: "Motoboys",
              to: "/usuarios/motoboys"
            },
            {
              name: "Parceiros",
              to: "/usuarios/parceiros"
            },
            {
              name: "Admins",
              to: "/usuarios/admins"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Usuários",
          icon: "cil-user",
          route: "/usuarios",
          meta: {
            roles: "SP|SF"
          },
          items: [
            {
              name: "Bikers",
              to: "/usuarios/bikers"
            },
            {
              name: "Motoboys",
              to: "/usuarios/motoboys"
            },
            {
              name: "Parceiros",
              to: "/usuarios/parceiros"
            },

          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Termos e regras",
          route: "/termos",

          icon: "cil-description",
          meta: { roles: "AD | SA" },
          items: [
            {
              name: "Termos de uso",
              to: "/termos/termos_uso"
            },
            // {
            //   name: 'Regras',
            //   to: '/termos/regras'
            // },
            {
              name: "Clube de vantagens",
              to: "/termos/vantagens"
            },
            {
              name: "Upload arquivos",
              to: "/termos/upload_arquivo"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Termos e regras",
          icon: "cil-description",
          route: "/termos",

          meta: { roles: "PE | MT" },
          items: [
            {
              name: "Termos de uso",
              to: "/termos/termos_uso"
            },
            // {
            //   name: 'Regras',
            //   to: '/termos/regras'
            // },
            {
              name: "Clube de vantagens",
              to: "/termos/vantagens"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Configurações",
          route: "/configuracoes",

          icon: "cil-settings",
          meta: { roles: "AD | SA | CO" },
          items: [
            {
              name: "Dados pessoais",
              to: "/configuracoes/informacoes_pessoas"
            },
            {
              name: "Endereço",
              to: "/configuracoes/endereco"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Configurações",
          route: "/configuracoes",

          icon: "cil-settings",
          meta: {
            roles: "SP|SF"
          },
          items: [{
              name: "Dados pessoais",
              to: "/configuracoes/informacoes_pessoas"
            },

          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: "Configurações",
          route: "/configuracoes",

          icon: "cil-settings",
          meta: { roles: "PE | MT" },
          items: [
            {
              name: "Dados pessoais",
              to: "/configuracoes/informacoes_pessoas"
            }
          ]
        }
      ]
    }
  ]
};
